import { Inject, Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from "@angular/router";
import { CoreInjectorTokensV2 } from "src/app/_enums/core-injector-tokens";
import { AuthService } from "src/app/_services/auth.service";
import { SnackbarService } from "src/app/_services/snackbar.service";
import { MessageTypeEnum } from "src/app/_enums/message-type.enum";

@Injectable({
    providedIn: "root",
})
export class AuthGuard {
    constructor(
        @Inject(CoreInjectorTokensV2.LoginUrl) private defaultUrl: string,
        private router: Router,
        private authService: AuthService,
        private readonly snackbarService: SnackbarService,
    ) {}

    canActivate(_: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
        if (this.authService.isAuthenticated && this.authService.isSuperAdmin) {
            if (state.url.includes("app/superadmin")) {
                return true;
            }

            this.snackbarService.show({ message: "Allowed only for users", type: MessageTypeEnum.ERROR });
            this.router.navigate(["app", "superadmin"]);

            return false;
        } else if (this.authService.isAuthenticated) {
            return true;
        }

        this.snackbarService.show({ message: "Login first", type: MessageTypeEnum.ERROR });
        this.router.navigate([this.defaultUrl], { state: { returnUrl: state.url } });

        return false;
    }

    canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
        return this.canActivate(route, state);
    }
}
